import { Component, ViewContainerRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';

import { GlobalState } from './global.state';
import { BaImageLoaderService, BaThemePreloader, BaThemeSpinner } from './theme/services';
import { BaThemeConfig } from './theme/theme.config';
import { layoutPaths } from './theme/theme.constants';

//SERVICES
import { EventsService } from "app/services/events";
import { AuthService } from "app/services/auth";

declare var require: any;

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  styleUrls: ['./app.component.scss'],
  template: `
    <main [class.menu-collapsed]="isMenuCollapsed" baThemeRun>
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
    </main>
  `
})
export class App {

  isMenuCollapsed: boolean = false;
  isLoading: boolean = false;

  private evento: any;

  constructor(private _state: GlobalState,
    private _imageLoader: BaImageLoaderService,
    private _spinner: BaThemeSpinner,
    private viewContainerRef: ViewContainerRef,
    private themeConfig: BaThemeConfig,
    private events: EventsService,
    private zone: NgZone,
    private authService: AuthService,
    private router: Router
  ) {

    themeConfig.config();

    this._loadImages();

    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });

    let evento = this.events.getEvento();

    this.evento = evento.subscribe((payload) => {
      switch (payload.tipo) {
        case 'loader:show':
          this.showLoader();
          break;
        case 'loader:hide':
          this.hideLoader();
          break;
        case 'user:login':
          console.log('logado');
          this.router.navigate(['/dashboard']).then(() => {
            this.hideLoader();
          });
          break;
        case 'user:logout':
          this.authService.logout().then(() => {
            console.log('deslogado');
            this.router.navigate(['/login']);
          });
          break;
      }
    });
  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  private _loadImages(): void {
    // register some loaders
    BaThemePreloader.registerLoader(this._imageLoader.load('assets/img/sky-bg.jpg'));
  }

  private showLoader() {
    this.zone.run(() => {
      if (!this.isLoading) {
        this.isLoading = true;
        this._spinner.show();
        console.log('Abriu Spinner');
      }
    });
  }

  private hideLoader() {
    this.zone.run(() => {
      console.log('Tenta Fechar Spinner');
      setTimeout(() => {
        if (this.isLoading) {
          this._spinner.hide();
          this.isLoading = false;
          console.log('Fechou Spinner');
        }
      }, 700);
    });
  }

}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/app.component.ts